import React from "react";
import { Route, Switch } from "react-router-dom";
import { CataloguePath } from "routes/createContent/paths";
import { CreateExercise } from "./CreateExercise";
import { EditExercise } from "./EditExercise";
import { Exercises } from "./Exercises";
import { ViewExercise } from "./ViewExercise";
import { CatalogueChangesPage } from "routes/createContent/components/CatalogueChangesPage";

export const ExerciseRoutes: React.VFC = () => (
  <Switch>
    <Route path={CataloguePath.Exercises_Changes}>
      <CatalogueChangesPage kind="exercise" backTo={CataloguePath.Exercises} />
    </Route>
    <Route path={`${CataloguePath.Exercises}/new`}>
      <CreateExercise />
    </Route>
    <Route path={`${CataloguePath.Exercises}/:id/edit`}>
      <EditExercise />
    </Route>
    <Route path={`${CataloguePath.Exercises}/:id`}>
      <ViewExercise />
    </Route>
    <Route path={CataloguePath.Exercises}>
      <Exercises />
    </Route>
  </Switch>
);
